import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line',
        // badge: {
        //     variant: 'success',
        //     text: 'MENUITEMS.DASHBOARDS.BADGE',
        // },
        link: '/customer/dashboard'
    },
    {
        id: 3,
        label: 'E-Sign',
        icon: 'ri-file-edit-line',
        subItems: [
            {
                id: 1,
                label: 'Create Document',
                link: '/customer/esign/send-document',
                parentId: 3
            },
            {
                id: 2,
                label: 'Documents',
                link: '/customer/esign/my-document',
                parentId: 3
            },
        ]
    },
    {
        id: 4,
        label: 'E-Stamp',
        icon: 'ri-file-paper-2-line',
        requiresEstamp: true,
        subItems: [
            {
                id: 1,
                label: 'Create Stamp Order',
                link: '/customer/estamp/create-order',
                parentId: 4
            },
            {
                id: 2,
                label: 'Stamp Orders',
                link: '/customer/estamp/bulk-order',
                parentId: 4
            },
            {
                id: 3,
                label: 'Create Customer Order',
                link: '/customer/estamp/create-customer-order',
                parentId: 4
            },
            {
                id: 4,
                label: 'Customer Orders',
                link: '/customer/estamp/customer-order-list',
                parentId: 4
            },
            {
                id: 5,
                label: 'Inventory List',
                link: '/customer/estamp/inventory',
                parentId: 4
            },
        ]
    },
    {
        id: 5,
        label: 'Templates',
        icon: 'ri-todo-line',
        link: '/customer/templates'
    },
    {
        id: 6,
        label: 'API & Integration',
        icon: 'ri-home-gear-line',
        link: '/customer/api-integration'
    },
    {
        id: 7,
        label: 'Billing',
        icon: 'ri-wallet-2-line',
        link: '/customer/billing'
    },
    {
        id: 7,
        label: 'S3 Storage',
        icon: 'ri-cloud-line',
        link: '/customer/s3-storage'
    },
    {
        id: 8,
        label: 'Account',
        icon: 'ri-store-2-line',
        link: '/customer/account'
    },

    // {
    //     id: 5,
    //     label: 'MENUITEMS.ECOMMERCE.TEXT',
    //     icon: 'ri-store-2-line',
    //     subItems: [
    //         {
    //             id: 6,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 7,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.PRODUCTDETAIL',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 8,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.ORDERS',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 9,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.CUSTOMERS',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 10,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.CART',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 11,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.CHECKOUT',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 12,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.SHOPS',
    //             link: '/',
    //             parentId: 5
    //         },
    //         {
    //             id: 13,
    //             label: 'MENUITEMS.ECOMMERCE.LIST.ADDPRODUCT',
    //             link: '/',
    //             parentId: 5
    //         },
    //     ]
    // }, 
];
